export enum ClientQueryKeys {
  getAllClients = "get-all-clients",
  deleteClient = "delete-client",
  getClientPackages = "get-client-packages",
  getASingleClientPackages = "get-a-single-client-package",
  downloadClientPackageBrochure = "download-client-package-brochure",
}
